import {Dialog, DialogProps} from '@mui/material';
import {ComponentWithOptionalChildren} from '../react/types';
import {useDeviceState} from './hooks/useDeviceState';

export type ResponsiveDialogProps = Omit<DialogProps, 'fullScreen'>;

export const ResponsiveDialog: ComponentWithOptionalChildren<ResponsiveDialogProps> = ({
  children,
  ...props
}: ResponsiveDialogProps) => {
  const {isNarrow} = useDeviceState();
  return (
    <Dialog {...props} fullScreen={isNarrow}>
      {children}
    </Dialog>
  );
};
